export const CURRENT_STEP = 'CURRENT_STEP';
export const IS_RECORDING = 'IS_RECORDING';
export const WAITING_COUNT = 'WAITING_COUNT';
export const IS_RECORDING_FINISHED = 'IS_RECORDING_FINISHED';
export const IS_RECORD_UPLOADED = 'IS_RECORD_UPLOADED';
export const IS_ASSETS_UPLOADED = 'IS_ASSETS_UPLOADED';
export const IS_ASSETS_UPLOAD_FAILURE = 'IS_ASSETS_UPLOAD_FAILURE';

export const handleIsAssetsUploadFailure = (value) => (dispatch) => {
  dispatch({
    type: IS_ASSETS_UPLOAD_FAILURE,
    payload: value,
  });
};

export const handleIsAssetsUploaded = (value) => (dispatch) => {
  dispatch({
    type: IS_ASSETS_UPLOADED,
    payload: value,
  });
};

export const handleCurrentStep = (id) => (dispatch) => {
  dispatch({
    type: CURRENT_STEP,
    payload: id,
  });
};

export const handleIsRecording = (value) => (dispatch) => {
  dispatch({
    type: IS_RECORDING,
    payload: value,
  });
};

export const handleIsRecordingFinished = (value) => (dispatch) => {
  dispatch({
    type: IS_RECORDING_FINISHED,
    payload: value,
  });
};

export const handleIsRecordUploaded = (value) => (dispatch) => {
  dispatch({
    type: IS_RECORD_UPLOADED,
    payload: value,
  });
};

export const handleWaitingCount = (value) => (dispatch) => {
  dispatch({
    type: WAITING_COUNT,
    payload: value,
  });
};
